(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mf-main-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var mfFiltersEl = document.getElementById('mf-filters');
    if (!mfFiltersEl) return;
    var mfDesktopQuery = window.matchMedia('(min-width: 1025px)');
    function mfSyncOffcanvasAria() {
      if (mfDesktopQuery.matches) {
        mfFiltersEl.removeAttribute('aria-hidden');
      } else if (!mfFiltersEl.classList.contains('is-open')) {
        mfFiltersEl.setAttribute('aria-hidden', 'true');
      }
    }
    mfSyncOffcanvasAria();
    mfDesktopQuery.addEventListener('change', mfSyncOffcanvasAria);
  })();

  } catch(e) { console.error(e); }
})();
})();
